import React from 'react';
import { SupplierOverview } from './components/SupplierOverview';
import { SupplierSettings } from './components/SupplierSettings';
export function App() {
  return <div className="w-full min-h-screen bg-gray-50" data-id="element-0">
      <SupplierSettings data-id="element-1" />
    </div>;
}